import { useState } from "react";
import {
  FormControl,
  NativeSelect
} from "@mui/material";
import { SiteSettingModalContainer, TagsTitle } from "../MapStyled";
import { CircleBtn } from "assets/css/globle";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SiteSetupAction } from "globalStore/globalStore";
import { siteSettingsTypes } from "constant";
import Draggable from "react-draggable";

const COGAndTeeAndPOIAddPopup = ({
  modalPos,
  setSiteSetupDialogBox,
  courseName,
  holeNo,
  holeCount,
  teeValue,
  addCogDistan,
  poiTypeValue,
  poiPositionValue,
  addCogTeePoiSaveActiveButton,
  cancelDialogOpen,
  saveMarkers,
  setCourseName,
  setHoleCount,
  setHoleNo,
  setAddCogTeePoiSaveActiveButton,
  setTeeValue,
  setPoiTypeValue,
  setPoiPositionValue
}) => {
  const { addSelectType } = useHookstate(SiteSetupAction);
  const { siteSettingsData, siteSetupData } = useSelector((state) => state.commonReducers) || [];

  const { t } = useTranslation();

  const [tempAreaPopupinitial, setTempAreaPopupinitial] = useState({
    site: null,
    hole: null,
    type: null,
  });

  const handleChange = (event) => {
    setCourseName(event.target.value);
    let data = siteSettingsData.Courses;
    let obj = data.find((o) => o.Number === parseInt(event.target.value));
    let holeNumber = obj?.HoleCount;

    setHoleCount(holeNumber);
    setHoleNo(1);
  }

  const handleHoleNo = (event) => {
    setHoleNo(event.target.value);
  }

  const teeHandleChange = (e) => {
    if (tempAreaPopupinitial.type === null)
      setTempAreaPopupinitial({ ...tempAreaPopupinitial, type: teeValue });
    else setAddCogTeePoiSaveActiveButton(false);
    setTeeValue(e.target.value);
  }

  const poiHandleChange = (e) => {
    setAddCogTeePoiSaveActiveButton(true);
    setPoiTypeValue(e.target.value);
  }

  const poiPositionHandleChange = (e) => {
    setAddCogTeePoiSaveActiveButton(true);
    setPoiPositionValue(e.target.value);
  }

  const draggableModalStyle = {
    position: "fixed",
    top: modalPos.y,
    left: modalPos.x,
    zIndex: 9999,
    background: "white",
    border: "1px solid #ccc",
    borderRadius: 8,
    width: 300,
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    padding: 20
  }

  const modalHeaderStyle = {
    padding: "0px 0px 10px 0px",
    cursor: "move",
    fontWeight: "bold",
    borderBottom: "1px solid #eee"
  }

  const selectLabelStyle = {
    color: "#7c7b7b",
    padding: "0px 0px 5px 0px",
  }

  const buttonsStyle = {
    display: "flex",
    padding: 10,
    gap: 5,
    justifyContent: "center"
  }

  return (
    <Draggable handle=".modal-header">
      <div style={draggableModalStyle}>
        <SiteSettingModalContainer>

          <div className="modal-header" style={modalHeaderStyle}>
            {t("Add_Site_Setting")}
          </div>

          <div style={selectLabelStyle}>
            {t("Select_Course")}
          </div>
          <FormControl fullWidth>
            <NativeSelect
              value={courseName}
              onChange={(e) => handleChange(e)}
            >
              <option key={-1} value={-1}>
                Select..
              </option>
              {siteSettingsData && siteSettingsData?.Courses?.map((item) => (
                <option key={item?.Number} value={item?.Number}>
                  {item?.Name}
                </option>
              ))}
            </NativeSelect>
          </FormControl>

          <div style={selectLabelStyle}>
            {t("Select_Hole")}
          </div>
          <FormControl fullWidth>
            <NativeSelect
              value={holeNo}
              onChange={(e) => handleHoleNo(e)}
            >
              {holeCount !== null &&
                [...Array(holeCount)].map((elementInArray, index) => (
                  <option key={index + 1} value={index + 1}>{index + 1}</option>
                ))}
            </NativeSelect>
          </FormControl>

          {addSelectType.get() === siteSettingsTypes.teeMarkers &&
            <>
              <div style={selectLabelStyle}>
                {t("Select_Tee")}
              </div>
              <FormControl fullWidth>
                <NativeSelect
                  value={teeValue}
                  onChange={(e) => teeHandleChange(e)}
                >
                  {siteSetupData.TeeMarkerSettings.map((item, i) => (
                    <option key={i} value={item.Id}>
                      {item.Name}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
              <TagsTitle>Distance (CoG): {addCogDistan} yd</TagsTitle>
            </>
          }

          {addSelectType.get() === siteSettingsTypes.pointOfInterest &&
            <>
              <div style={selectLabelStyle}>
                {t("Select_Type")}
              </div>
              <FormControl fullWidth>
                <NativeSelect
                  value={poiTypeValue}
                  onChange={(e) => poiHandleChange(e)}
                >
                  <option value={2}>{t("Hole")}</option>
                  <option value={3}>{t("Approach")}</option>
                </NativeSelect>
              </FormControl>
              <div style={selectLabelStyle}>
                {t("Select_Position")}
              </div>
              <FormControl fullWidth>
                <NativeSelect
                  value={poiPositionValue}
                  onChange={(e) => poiPositionHandleChange(e)}
                >
                  <option value={0}>{t("Left")}</option>
                  <option value={1}>{t("Right")}</option>
                  <option value={2}>{t("Above")}</option>
                  <option value={3}>{t("Below")}</option>
                </NativeSelect>
              </FormControl>
            </>
          }

          <div style={buttonsStyle}>
            <CircleBtn
              disabled={!addCogTeePoiSaveActiveButton}
              onClick={saveMarkers}
              className={addCogTeePoiSaveActiveButton ? "active" : "disabled"}
            >
              {t("Save")}
            </CircleBtn>
            <CircleBtn onClick={() => { cancelDialogOpen("cancelMarkers"); setSiteSetupDialogBox(null); }}>
              {t("Cancel")}
            </CircleBtn>
          </div>
        </SiteSettingModalContainer>
      </div>
    </Draggable>
  );
};

export default COGAndTeeAndPOIAddPopup;
